export default {
  filterHistory: [],
  cartCache: false
}
